import { type FunctionComponent } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';
import { useBoardId } from '@trello/id-context';
import { useLazyComponent } from '@trello/use-lazy-component';

import { LazyBoardPowerUpsDirectory } from 'app/src/components/BoardPowerUpsDirectory';

export const BoardPowerUpsView: FunctionComponent = () => {
  const boardId = useBoardId();

  const LegacyPluginView = useLazyComponent(
    () =>
      import(/* webpackChunkName: "legacy-plugin-view" */ './LegacyPluginView'),
    { preload: false, namedImport: 'LegacyPluginView' },
  );

  const { value: isPUpDirectoryModernizationEnabled } = useFeatureGate(
    'phx_pup_directory_modernization',
  );

  if (isPUpDirectoryModernizationEnabled) {
    return <LazyBoardPowerUpsDirectory />;
  }
  return <LegacyPluginView boardId={boardId} />;
};
